import { EmailGate } from "@/components/EmailGate";
import { Reveal } from "@/components/motion";

export const FinalCta = () => (
  <section className="border-t border-white/10 bg-[#0A0A0A] blueprint-grid" data-testid="final-cta">
    <div className="px-6 sm:px-12 lg:px-20 py-24 max-w-[1400px] mx-auto">
      <Reveal>
        <p className="label-mono mb-4 flex items-center gap-3">
          <span className="inline-block w-8 h-px bg-[#FF3B00]" /> 05 — Get the build
        </p>
        <h2 className="font-display font-bold uppercase tracking-tighter text-5xl sm:text-7xl leading-[0.9] max-w-3xl">
          Free for your <span className="text-[#FF3B00]">workshop.</span>
        </h2>
        <p className="mt-6 max-w-lg text-white/70 leading-relaxed">
          Type your email below — it's added to the list automatically, the moment you hit the button.
          Confirm it once via the verification link and your download unlocks instantly.
          No waiting, no approval step. We'll only write when a new build ships.
        </p>
      </Reveal>
      <Reveal delay={0.15} className="mt-10">
        <EmailGate />
      </Reveal>
    </div>
  </section>
);
